import React from 'react';

import { UiButton } from '../../ui/ui-button';
import { AnnouncementComposer } from '../announcement-composer/announcement-composer';
import { EmployeeGroupAnnouncements } from '../message-thread/employee-group-thread/employee-group-announcements';

type InputProps = {
  orgId: number;
  onClose: () => void;
  onChange?: (employeeGroup: EmployeeGroupWithAllOption | null) => void;
  defaultToAllEmployees?: boolean;
  autoFocus?: boolean;
  hideThread?: boolean;
  className?: string;
  initialMessage?: string;
  onMessageSent?: () => void;
  activeEmployeeGroupId: string | number | null;
};

export const NewAnnouncementComposer = (props: InputProps) => {
  const {
    orgId,
    onClose,
    className,
    initialMessage,
    onMessageSent,
    hideThread,
    activeEmployeeGroupId,
  } = props;

  const renderThread = (employeeGroupId: number) => (
    <div className="u-flexGrow-1 u-overflowY-scroll u-padding u-no-padding-top">
      <div className="u-maxWidth-800px u-margin-0Auto">
        <EmployeeGroupAnnouncements
          onMessageSent={onMessageSent}
          initialMessage={initialMessage}
          orgId={orgId}
          employeeGroupId={employeeGroupId}
          onClose={() => {}}
        />
      </div>
    </div>
  );

  const renderComposerOnly = (employeeGroupId: number) => (
    <div className="u-padding">
      <AnnouncementComposer
        initialMessage={initialMessage}
        onMessageSent={onMessageSent}
        orgId={orgId}
        employeeGroupId={employeeGroupId}
        onClose={onClose}
      />
    </div>
  );

  const renderEmptyState = () => (
    <div className="u-display-flex u-flexGrow-1 u-alignItems-center u-justifyContent-center u-padding-2x">
      <div className="u-display-flex u-flexDirection-column u-alignItems-center">
        <div className="typo-h6">Select a group to send an announcement</div>
        <UiButton variant="dismiss" onClick={onClose} dataCy="empty-state-cancel">
          Cancel
        </UiButton>
      </div>
    </div>
  );

  return (
    <div
      className={`u-display-flex u-flexDirection-column u-height-100 u-overflowY-auto ${
        className || ''
      }`}
    >
      {activeEmployeeGroupId && !hideThread && renderThread(activeEmployeeGroupId as number)}
      {activeEmployeeGroupId && hideThread && renderComposerOnly(activeEmployeeGroupId as number)}
      {!activeEmployeeGroupId && renderEmptyState()}
    </div>
  );
};
